import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetLookUpDropdownListQuery } from '../../api/endpoints/lookup';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Alınan Teminatlar ekranındaki teminat türü seçimi.
 * `CollateralBankDropdown.jsx` ile aynı desen: proje genelindeki paylaşılan lookup ucu
 * kullanılır (`v1/lookup/get?GroupCode=COLLATERAL_TYPE`). `type` alanı backend'de int
 * olarak saklandığından (bkz. docs/CollateralReceived-API.md §3.3), lookup'ın `code`
 * alanı sayıya çevrilerek value olarak kullanılır — `OtherCostDropdown.jsx`'teki
 * `Number(costType.code)` deseniyle birebir aynı.
 */
const CollateralTypeDropdown = ({ value, onChange, className, placeholder, disabled = false }) => {
    const { getCurrentLanguageId } = useLanguage();

    const { data: raw = [], isLoading } = useGetLookUpDropdownListQuery({
        GroupCode: 'COLLATERAL_TYPE',
        LanguageId: getCurrentLanguageId() ?? 2
    });

    const options = useMemo(() => {
        const items = Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : [];
        return items
            .filter((item) => item.code != null)
            .map((item) => ({
                label: item.translatedText || String(item.code),
                value: Number(item.code)
            }));
    }, [raw]);

    return (
        <Dropdown
            value={value ?? null}
            onChange={(e) => onChange?.(e.value)}
            options={options}
            optionLabel="label"
            optionValue="value"
            className={className}
            placeholder={placeholder}
            disabled={disabled || isLoading}
            loading={isLoading}
            showClear
            appendTo={document.body}
        />
    );
};

export default CollateralTypeDropdown;
